import React, { Component } from "react";
class ProcessPayroll extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="leaf-page-container">
        <h1>ProcessPayroll</h1>
      </div>
    );
  }
}

export default ProcessPayroll;
